/* global jQuery, orbito */

(function ($) {
  'use strict';

  /**
   * Initializes the SONGZIO country/language selector.
   * Country and language clicks only update the pending selection. The actual
   * Market/language change is performed when CHANGE LOCATION is pressed.
   */
  function initializeLocationSwitcher($root) {
    var $drawer = $root.find('[data-songzio-location-drawer]');
    var $overlay = $root.find('[data-songzio-location-overlay]');
    var $openButton = $root.find('[data-songzio-location-open]');
    var $mobileOpenButtons = $('[data-songzio-mobile-location-open]');
    var $closeButton = $root.find('[data-songzio-location-close]');
    var $applyButton = $root.find('[data-songzio-location-apply]');
    var $regions = $root.find('[data-songzio-regions]');
    var $countryInput = $root.find('[data-songzio-country-input]');
    var $languageInput = $root.find('[data-songzio-language-input]');
    var $form = $root.find('#SongzioLocalizationForm');
    var $returnToInput = $form.find('input[name="return_to"]');
    var currentCountryCode = String($root.data('current-country') || $countryInput.val() || '').toUpperCase();
    var currentLanguageCode = String($root.data('current-language') || $languageInput.val() || '').toLowerCase();
    var isChangingLocation = false;
    var cookieMaxAge = 60 * 60 * 24 * 60;
    var $footerSection = $root.closest('.section');

    /*
     * Move the switcher shell to <body> before opening the drawer.
     * The SONGZIO theme has transformed/contained ancestors around the footer,
     * which can make position:fixed use the footer as its containing block.
     * Portaling the shell to <body> guarantees that the drawer uses the real
     * browser viewport and prevents the LANGUAGE / CHANGE LOCATION area from
     * being clipped below the screen.
     */
    if (!$root.parent().is('body')) {
      $root.appendTo('body');
    }

    /** Places the COUNTRY trigger immediately before the first footer menu item. */
    function placeTriggerInFooterMenu() {
      var $primaryFooterMenu = $footerSection
        .find('.footer-content .menu')
        .first()
        .find('.details-content ul')
        .first();

      if ($primaryFooterMenu.length === 0) {
        return;
      }

      var $existingMenuItem = $primaryFooterMenu.find('.songzio-location-switcher__menu-item');

      if ($existingMenuItem.length > 0) {
        $existingMenuItem.empty().append($openButton);
        return;
      }

      var $menuItem = $('<li class="menu__item paragraph songzio-location-switcher__menu-item"></li>');
      $menuItem.append($openButton);
      $primaryFooterMenu.prepend($menuItem);
    }

    /** Returns the cookie domain Orbe expects for the current Shopify storefront. */
    function getOrbeCookieDomain() {
      var hostname = window.location.hostname.replace(/^www\./, '');

      if (typeof orbito !== 'undefined' && typeof orbito.getCountryDomain === 'function') {
        return orbito.getCountryDomain() || hostname;
      }

      return hostname;
    }

    /** Writes a preference cookie using a domain only when one is available. */
    function setPreferenceCookie(name, value, domain, maxAge) {
      var cookieParts = [
        name + '=' + encodeURIComponent(value),
        'path=/',
        'max-age=' + maxAge,
        'SameSite=Lax'
      ];

      if (domain) {
        cookieParts.push('domain=' + domain);
      }

      if (window.location.protocol === 'https:') {
        cookieParts.push('Secure');
      }

      document.cookie = cookieParts.join('; ');
    }

    /** Synchronizes the final country selection with Orbe. */
    function syncOrbeCountry(countryCode) {
      setPreferenceCookie('mdApp_countryCodeDomain', countryCode, getOrbeCookieDomain(), cookieMaxAge);
    }

    /** Synchronizes the final language selection with Orbe. */
    function syncOrbeLanguage(languageCode) {
      setPreferenceCookie('mdApp_showRecommendationLang', languageCode, getOrbeCookieDomain(), cookieMaxAge);
    }

    /** Collapses every region so the drawer always opens like the reference design. */
    function collapseAllRegions() {
      $root.find('.songzio-location-switcher__region').removeClass('is-open');
      $root.find('[data-songzio-region-toggle]').attr('aria-expanded', 'false');
      $root.find('[data-songzio-country-list]').prop('hidden', true).removeAttr('style');
    }

    /** Restores pending country/language selections to the currently active values. */
    function resetPendingSelection() {
      $countryInput.val(currentCountryCode);
      $languageInput.val(currentLanguageCode);

      $root.find('[data-songzio-country]')
        .removeClass('is-selected')
        .attr('aria-pressed', 'false')
        .filter('[data-country-code="' + currentCountryCode + '"]')
        .addClass('is-selected')
        .attr('aria-pressed', 'true');

      $root.find('[data-songzio-language]')
        .removeClass('is-selected')
        .attr('aria-pressed', 'false')
        .filter('[data-language-code="' + currentLanguageCode + '"]')
        .addClass('is-selected')
        .attr('aria-pressed', 'true');
    }

    /** Opens the fixed drawer and resets its scroll/accordion state. */
    function openDrawer() {
      resetPendingSelection();
      collapseAllRegions();
      $regions.scrollTop(0);
      $overlay.prop('hidden', false);
      $drawer.prop('hidden', false);

      window.requestAnimationFrame(function () {
        $drawer.addClass('is-open');
        $openButton.attr('aria-expanded', 'true');
        $mobileOpenButtons.attr('aria-expanded', 'true');
        $('html').addClass('songzio-location-switcher-open');
      });
    }

    /** Closes the drawer and restores document scrolling. */
    function closeDrawer() {
      $drawer.removeClass('is-open');
      $openButton.attr('aria-expanded', 'false');
      $mobileOpenButtons.attr('aria-expanded', 'false');
      $('html').removeClass('songzio-location-switcher-open');

      window.setTimeout(function () {
        $drawer.prop('hidden', true);
        $overlay.prop('hidden', true);
      }, 260);
    }

    /** Returns the shared SONGZIO cookie domain on production domains. */
    function getSongzioCookieDomain() {
      var hostname = window.location.hostname.toLowerCase();

      if (hostname === 'songzio.com' || hostname.slice(-12) === '.songzio.com') {
        return '.songzio.com';
      }

      return '';
    }

    /** Stores the explicit South Korea selection for 30 days. */
    function rememberKoreaSelection() {
      var cookieDomain = getSongzioCookieDomain();
      var cookieParts = [
        'songzio_country_override=KR',
        'path=/',
        'max-age=' + (60 * 60 * 24 * 30),
        'SameSite=Lax'
      ];

      if (cookieDomain !== '') {
        cookieParts.push('domain=' + cookieDomain);
      }

      if (window.location.protocol === 'https:') {
        cookieParts.push('Secure');
      }

      document.cookie = cookieParts.join('; ');
    }

    /** Clears the Korea override after the user explicitly chooses another country. */
    function clearKoreaSelection() {
      var cookieDomain = getSongzioCookieDomain();
      var cookieParts = [
        'songzio_country_override=',
        'path=/',
        'max-age=0',
        'SameSite=Lax'
      ];

      if (cookieDomain !== '') {
        cookieParts.push('domain=' + cookieDomain);
      }

      if (window.location.protocol === 'https:') {
        cookieParts.push('Secure');
      }

      document.cookie = cookieParts.join('; ');
    }

    /** Keeps advertising/query parameters when leaving Shopify for the Korean store. */
    function buildExternalUrl(baseUrl) {
      var currentUrl = new URL(window.location.href);

      currentUrl.searchParams.delete('preview_theme_id');
      currentUrl.searchParams.delete('_ab');
      currentUrl.searchParams.delete('_fd');
      currentUrl.searchParams.delete('_sc');

      if (currentUrl.searchParams.toString() === '') {
        return baseUrl;
      }

      return baseUrl + '?' + currentUrl.searchParams.toString();
    }

    /** Adds the selected country to return_to before Shopify changes Markets. */
    function updateReturnToCountry(countryCode) {
      var currentUrl = new URL(window.location.href);
      var returnTo = currentUrl.pathname + currentUrl.search + currentUrl.hash;
      var separator = returnTo.indexOf('?') === -1 ? '?' : '&';

      if (/(\?|&)country=[^&]*/.test(returnTo)) {
        returnTo = returnTo.replace(/(\?|&)country=[^&]*/, '$1country=' + encodeURIComponent(countryCode));
      } else {
        returnTo += separator + 'country=' + encodeURIComponent(countryCode);
      }

      if ($returnToInput.length > 0) {
        $returnToInput.val(returnTo);
      }
    }

    /** Submits Shopify's native localization form using the pending values. */
    function submitLocalization(countryCode, languageCode) {
      if (isChangingLocation || $form.length === 0 || !$form.get(0)) {
        return;
      }

      isChangingLocation = true;
      $countryInput.val(countryCode);
      $languageInput.val(languageCode);
      $form.get(0).submit();
    }

    placeTriggerInFooterMenu();

    $openButton.on('click', function () {
      openDrawer();
    });

    $mobileOpenButtons.on('click', function (event) {
      var headerDrawer = $(this).closest('header-drawer').get(0);
      var $menuDetails = $(this).closest('details.menu-drawer-container');

      event.preventDefault();
      event.stopPropagation();

      if (headerDrawer && typeof headerDrawer.close === 'function') {
        headerDrawer.close();

        window.setTimeout(function () {
          openDrawer();
        }, 300);

        return;
      }

      if ($menuDetails.length > 0) {
        $menuDetails
          .removeClass('menu-open')
          .removeAttr('open')
          .find('> summary')
          .attr('aria-expanded', 'false');
      }

      window.setTimeout(function () {
        openDrawer();
      }, 30);
    });

    $closeButton.add($overlay).on('click', function () {
      closeDrawer();
    });

    $root.find('[data-songzio-region-toggle]').on('click', function () {
      var $toggle = $(this);
      var $region = $toggle.closest('.songzio-location-switcher__region');
      var $list = $region.find('[data-songzio-country-list]').first();
      var willOpen = !$region.hasClass('is-open');

      $root.find('.songzio-location-switcher__region').not($region).removeClass('is-open');
      $root.find('[data-songzio-region-toggle]').not($toggle).attr('aria-expanded', 'false');
      $root.find('[data-songzio-country-list]').not($list).stop(true, true).hide().prop('hidden', true).removeAttr('style');

      $region.toggleClass('is-open', willOpen);
      $toggle.attr('aria-expanded', willOpen ? 'true' : 'false');

      if (willOpen) {
        $list.stop(true, true).hide().prop('hidden', false).slideDown(180, function () {
          $list.removeAttr('style');
        });
      } else {
        $list.stop(true, true).slideUp(180, function () {
          $list.prop('hidden', true).removeAttr('style');
        });
      }
    });

    /** Country clicks only mark the pending selection. */
    $root.find('[data-songzio-country]').on('click', function (event) {
      var $country = $(this);
      var countryCode = String($country.data('country-code') || '').toUpperCase();

      event.preventDefault();
      event.stopPropagation();

      if (isChangingLocation || countryCode === '') {
        return;
      }

      $root.find('[data-songzio-country]')
        .removeClass('is-selected')
        .attr('aria-pressed', 'false');

      $country
        .addClass('is-selected')
        .attr('aria-pressed', 'true');

      $countryInput.val(countryCode);
    });

    /** Language clicks only mark the pending selection. */
    $root.find('[data-songzio-language]').on('click', function (event) {
      var $language = $(this);
      var languageCode = String($language.data('language-code') || '').toLowerCase();

      event.preventDefault();
      event.stopPropagation();

      if (isChangingLocation || languageCode === '') {
        return;
      }

      $root.find('[data-songzio-language]')
        .removeClass('is-selected')
        .attr('aria-pressed', 'false');

      $language
        .addClass('is-selected')
        .attr('aria-pressed', 'true');

      $languageInput.val(languageCode);
    });

    /** Applies both pending values only when CHANGE LOCATION is pressed. */
    $applyButton.on('click', function (event) {
      var selectedCountryCode = String($countryInput.val() || currentCountryCode).toUpperCase();
      var selectedLanguageCode = String($languageInput.val() || currentLanguageCode).toLowerCase();
      var $selectedCountry = $root.find('[data-songzio-country].is-selected').first();
      var externalUrl = String($selectedCountry.data('external-url') || '');

      event.preventDefault();
      event.stopPropagation();

      if (isChangingLocation || selectedCountryCode === '') {
        return;
      }

      if (selectedCountryCode === 'KR' && externalUrl !== '') {
        isChangingLocation = true;
        rememberKoreaSelection();
        window.location.assign(buildExternalUrl(externalUrl));
        return;
      }

      clearKoreaSelection();
      syncOrbeCountry(selectedCountryCode);

      if (selectedLanguageCode !== '') {
        syncOrbeLanguage(selectedLanguageCode);
      }

      if (selectedCountryCode === currentCountryCode && selectedLanguageCode === currentLanguageCode) {
        closeDrawer();
        return;
      }

      updateReturnToCountry(selectedCountryCode);
      submitLocalization(selectedCountryCode, selectedLanguageCode);
    });

    $(document).on('keydown.songzioLocationSwitcher', function (event) {
      if (event.key === 'Escape' && !$drawer.prop('hidden')) {
        closeDrawer();
      }
    });
  }

  function detectInstagramInAppBrowser() {
    var userAgent = String(window.navigator.userAgent || '');
    var isInstagram = /Instagram/i.test(userAgent);

    document.documentElement.classList.toggle('songzio-instagram-inapp', isInstagram);
  }

  function syncMobileVisualViewportHeight() {
    if (window.matchMedia && !window.matchMedia('(max-width: 749px)').matches) {
      document.documentElement.style.removeProperty('--songzio-mobile-visual-height');
      return;
    }

    var viewportHeight = window.innerHeight;

    if (window.visualViewport && window.visualViewport.height) {
      viewportHeight = window.visualViewport.height;
    }

    if (viewportHeight > 0) {
      document.documentElement.style.setProperty(
        '--songzio-mobile-visual-height',
        Math.round(viewportHeight) + 'px'
      );
    }
  }

  $(function () {
    detectInstagramInAppBrowser();
    syncMobileVisualViewportHeight();

    $('[data-songzio-location-switcher]').each(function () {
      initializeLocationSwitcher($(this));
    });

    $(window).on('resize.songzioMobileViewport orientationchange.songzioMobileViewport', function () {
      syncMobileVisualViewportHeight();
    });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncMobileVisualViewportHeight);
      window.visualViewport.addEventListener('scroll', syncMobileVisualViewportHeight);
    }
  });
})(jQuery);
